export default "__VITE_ASSET__C3xeEOo0__"